@if (order.status) {
  <div class="d-flex flex-column">
    @if (!isCompleted(order.status.id)) {
      <div class="order-status-dropdown mb-4">
        <dx-drop-down-button
          [text]="order && order.status ? order.status.name : (translate.get('CREATING') | async)"
          [items]="statuses$ | async"
          displayExpr="name"
          class="d-block"
          keyExpr="id"
          itemTemplate="status-item"
          (onItemClick)="onStatusChangeClick($event)"
          [dropDownOptions]="{ width: 250 }">
          <div *dxTemplate="let data of 'status-item'" class="status-item">
            @if (data.id === order.status.id) {
              <div>
                <span class="status-item-name">{{ data.name }}</span>
                <span class="status-item-current">{{ 'CURRENT' | translate }}</span>
              </div>
            }
            @if (data.id !== order.status.id) {
              <div>
                <span class="status-item-name">{{ data.name }}</span>
              </div>
            }
          </div>
        </dx-drop-down-button>
      </div>
    }
    @if (isCompleted(order.status.id)) {
      <div class="order-status-action d-flex flex-column flex-md-row justify-content-end mb-4">
        @for (status of statuses$ | async; track status) {
          <dx-button
            text="{{ getStatusButtonText(status) }}"
            (onClick)="onStatus(status)"
            [ngClass]="getButtonClass(status)"
            class="ml-md-2 ms-0 mb-2 mb-md-0"></dx-button>
        }
      </div>
    }
    @if (this.isForApproval(this.order.status.id)) {
      <div class="text-end">
        <div class="d-inline-block border text-start rounded">
          <h2 class="px-4 py-3 border-bottom font-size-18 bg-grey-light-l rounded-top">
            {{ 'ORDER_REQUIRES_APPROVAL' | translate }}
          </h2>
          <div class="px-4 pt-2 pb-3">
            <div class="mb-3">
              <dx-button
                text="{{ 'APPROVE' | translate }}"
                (onClick)="this.changeStatus(this._orderStatuses.Agreed)"
                ngClass="btn btn-green"></dx-button>
              <dx-button
                text="{{ 'NEEDS_CLARIFICATION' | translate }}"
                (onClick)="this.changeStatus(this._orderStatuses.RequiresClarification)"
                ngClass="btn btn-light"
                class="ms-3"></dx-button>
            </div>
            <div class="font-size-15 color-grey-label mb-1">{{ 'CURRENT_COORDINATOR' | translate }}:</div>
            @if (this.order.coordinator) {
              <div class="color-black">{{ this.order.coordinator.fio }}</div>
            }
          </div>
        </div>
      </div>
    }
  </div>
}

<app-dialog-change-order-status></app-dialog-change-order-status>
